
// Blatant "inspiration" from https://codepen.io/Jacqueline34/pen/pyVoWr
const convertRowsWithColumnsToCSV = (rowData, columns) => {

    const rowToString = row =>
        row.reduce((prev, curr, index) => {
            if (0 === index) {
                return '"' + curr + '"';
            } else {
                return prev + ',"' + curr + '"';
            }
        }, '') + ',\r\n';

    const columnHeadings    = rowToString(columns.map(c=> c.name));
    const rowSelectedData   = rowData.map(d => columns.map(c => c.selector(d)));
    const rowStrings        = rowSelectedData.map(rd => rowToString(rd));

    const allRowsString     = rowStrings.reduce((prev, curr) => prev + '' + curr, '');

    /* we don't show totals for the availability view which doesn't have 
        minutes column data which results in NaN */
    const totalMinutes      = rowData.reduce((prev, current) => prev + current.totalMinutes, 0);
    const totalInHours        = Number.isNaN(totalMinutes)? "": Math.floor(totalMinutes/60);
    const totalInMinutes      = Number.isNaN(totalMinutes)? "": totalMinutes%60;
    const totalRow          = Number.isNaN(totalMinutes)? "": ("\r\n,,,Total number of (Minutes)," + totalMinutes + "\r\n,,,Time," + totalInHours + " hours and " + totalInMinutes + " minutes");

    const result            = columnHeadings + '\r\n' + allRowsString + totalRow;

    return result;
}

const createCsvURL = (data, columns) => {

    let csv = convertRowsWithColumnsToCSV(data, columns);

    if (!csv?.match(/^data:text\/csv/i)) {
        csv = `data:text/csv;charset=utf-8,${csv}`;
    }

    return csv;
}

export default createCsvURL;